<template>
  <div class="jdindentlist">
    <div class="indentlist-top">
      <i class="el-icon-back zzzd_icon" @click="goBack"></i>
      <span>需求详情</span>
    </div>
    <div class="contentWrap">
      <!-- <div class="result">
        <el-button type="primary" size="mini" @click="resoultDialogVisible = true">认证结果</el-button>
      </div>-->
      <div class="jdindentList-container">
        <div class="container_item">
          <h1>当前状态</h1>
          <el-steps :active="statusType" simple>
            <el-step title="未推送"></el-step>
            <el-step title="已推送"></el-step>
            <el-step title="已跟进"></el-step>
            <el-step title="已成单"></el-step>
            <el-step title="已关闭"></el-step>
          </el-steps>
        </div>
        <div class="container_item" style="height:100%">
          <h1>申请概览</h1>
          <div class="container_item_box">
            <div class="container_item_box_item">
              <div>
                <label>创建时间</label>
                <span>{{details.created_at}}</span>
              </div>
              <div>
                <label>需求ID</label>
                <span>{{details.needNo||"--"}}</span>
              </div>
              <div>
                <label>公司名称</label>
                <span>{{details.publishName}}</span>
              </div>
              <div>
                <label>联系人姓名</label>
                <span>{{details.followManName}}</span>
              </div>
              <div>
                <label>需求内容</label>
                <span>{{details.publishContent}}</span>
              </div>
            </div>
            <div class="container_item_box_item">
              <div>
                <label>需求状态</label>
                <span>{{details.statusName}}</span>
              </div>
              <div>
                <label>需求类型</label>
                <span>{{details.typeName}}</span>
              </div>
              <div>
                <label>申请区域</label>
                <span>{{details.city}}</span>
              </div>
              <div>
                <label>联系电话</label>
                <span>{{details.publishMobile}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="container_item" style="height:100%" v-if="statusType == 2">
          <h1>方案详情</h1>
          <div class="container_item_box">
            <div class="container_item_box_item">
              <div>
                <label>公司名称</label>
                <span>{{details.publishName}}</span>
              </div>
              <div>
                <label>申请区域</label>
                <span>{{details.city}}</span>
              </div>
              <div>
                <label>方案总价</label>
                <span>{{details.followManName}}</span>
              </div>
              <div>
                <label>服务价格</label>
                <span>{{details.publishContent}}</span>
              </div>
            </div>
            <div class="container_item_box_item">
              <div>
                <label>服务类型</label>
                <span>{{details.publishName}}</span>
              </div>
              <div>
                <label>方案状态</label>
                <span>{{details.statusName}}</span>
              </div>
              <div>
                <label>备注</label>
                <span>{{details.typeName}}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="statusType == 2" class="btnWrap">
          <el-button type="primary" size="small">立即支付</el-button>
          <el-button size="small" @click="centerDialogVisible = true">退回方案</el-button>
        </div>
        <el-dialog title="退回方案" :visible.sync="centerDialogVisible" width="40%" center>
          <div>退回原因</div>
          <el-form label-width="80px" :model="ruleForm" ref="ruleForm" :rules="rules" >
            <div>
              <span style="margin-left:50px">需求ID ：</span>
              <span>{{details.needNo||"--"}}</span>
            </div>
            <el-form-item label="关闭原因" style="margin-left:35px" prop="desc">
              <el-input type="textarea" v-model="ruleForm.desc"></el-input>
            </el-form-item>
            <el-form-item   class="formBtnWrap">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { getItemByNeedNo } from "@/api/zzzd_onNeed.js";
import { logout } from "@/api/user";
import { getCookie, removeCookie } from "@/utils/getToken.js";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      details: {},
      ruleForm: {
        desc: "",
      },
      rules: {
        desc: [
          { required: true, message: '请填写活动形式', trigger: 'blur' }
        ]
      },
      statusType: 0,
      centerDialogVisible: false, //退回方案弹窗
    };
  },
  methods: {
    //详情
    getDataDatails() {
      let params = {
        needNo: this.$route.query.needNo,
      };
      getItemByNeedNo(params)
        .then((res) => {
          if (res.status == 0) {
            this.details = res.data;
            let type = res.data.status;
            switch (type) {
              case 'wts':
                this.statusType = 0
                break;
              case 'yts':
                this.statusType = 1
                break;
              case 'ygj':
                this.statusType = 2
                break;
              case 'ycd':
                this.statusType = 3
                break;
              case 'ygb':
                this.statusType = 4
                break;
              default:
                break;
            }

            this.details.created_at = moment(this.details.created_at).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            if (this.details.typeName == null && this.details.notes != null) {
              this.details.typeName = this.details.notes;
            } else if (
              this.details.typeName == null &&
              this.details.notes == null
            ) {
              this.details.typeName = "其他";
            }
          } else if (res.status == -99) {
            this.$message("登录超时，请重新登录");
            this.logout();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    logout() {
      logout(getCookie("userpin")).then((res) => {
        if (res.status == 0) {
          removeCookie("userpin");
          removeCookie("username");
          // this.$message({
          //   message: "已退出登录！",
          //   type: "success",
          // });
          this.$router.push("/diagnose");
        } else {
          this.$message.error("退出登录失败！");
        }
      });
    },
    // 确认
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          this.centerDialogVisible = false
          this.ruleForm.desc = ''
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 取消
    cancel(){
      this.centerDialogVisible = false
      this.ruleForm.desc = ''
    }
  },
  mounted() {
    this.getDataDatails();
  },
};
</script>

<style lang="scss">
.jdindentlist {
  width: 100%;
  min-height: 100%;
  background: #ebecef;
}
.indentlist-top {
  width: 100%;
  height: 50px;
  background: #fff;
  font-size: 18px;
  padding-left: 20px;
  line-height: 50px;
  font-weight: 600;
  .zzzd_icon {
    color: #409eff;
    margin-right: 10px;
    cursor: pointer;
  }
}
.contentWrap {
  padding: 20px;
}
.result {
  text-align: left;
  padding: 10px 0;
}
.jdindentList-container {
  width: 100%;
  .container_item {
    height: 100px;
    width: 100%;
    background: #ffffff;
    margin-bottom: 20px;
    h1 {
      text-align: left;
      line-height: 45px;
      font-size: 14px;
      font-weight: 600;
      color: #000;
      margin-left: 20px;
    }
    .container_item_box {
      display: flex;
      .container_item_box_item {
        width: 50%;
        text-align: left;
        margin-left: 20px;
        line-height: 40px;
        div {
          display: flex;
          label {
            color: #888888;
            font-size: 12px;
            font-weight: 400;
            width: 80px;
          }
          span {
            color: #333333;
            font-size: 12px;
            font-weight: 400;
          }
        }
      }
    }
  }
  .btnWrap {
    display: flex;
    justify-content: center;
  }
  .el-dialog{
    .formBtnWrap{
      margin-top:40px;
      margin-left: -80px;
      display: flex;
      justify-content: center;
    }
  }
}
.el-dialog {
  div {
    line-height: 45px;
  }
}
.el-steps--simple {
  background: #ffffff;
}
</style>
